const PERMISSION_KEY= "core:contact_form";
const PAGE_URL = {
    CONTACT_FORM_PAGE: "/admin/core/contact-form"
}

export {PERMISSION_KEY, PAGE_URL}

